import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { IconProps, RadioChecked, RadioUnchecked } from '../../common/icons';

const styles = require('./radio-item.css');

/**
 * Props for the check item
 * Note: Doesn't work well for large sizes
 */
export interface RadioItemProps {
  /** Additional classes */
  className?: string;
  /** Additional classes for text */
  textClassName?: string;
  /** Size of the radio button */
  size: IconProps['size'];
  /** Label to show */
  label: string;
  /** Hint text for the question */
  hintText?: string;
  /** Whether it is selected */
  selected: boolean;
  /** Selection change handler */
  onChange?(value: boolean): void;
  /** Disabled */
  disabled?: boolean;
  /** Outlined */
  outlined?: boolean;
}

/**
 * A Check box and  a label.
 */
@observer
export class RadioItem extends React.Component<RadioItemProps> {
  /** Renders the component */
  render() {
    return (
      <div
        className={classnames(
          styles.checkItem,
          this.props.outlined ? styles.outlined : undefined,
          this.props.className
        )}
        onClick={this.props.disabled ? undefined : this.onToggle}
      >
        {this.props.selected ? (
          <RadioChecked
            size={this.props.size}
            className={this.props.disabled ? styles.disabled : undefined}
            color='primary'
          />
        ) : (
          <RadioUnchecked
            size={this.props.size}
            className={this.props.disabled ? styles.disabled : undefined}
            color={this.props.outlined ? 'black' : undefined}
          />
        )}

        <div
          className={this.props.selected ? classnames(styles.checkItemLabel, styles.selected) : styles.checkItemLabel}
        >
          <div className={this.props.textClassName}>{this.props.label}</div>
          {this.props.hintText && <div className={styles.hintText}>{this.props.hintText}</div>}
        </div>
      </div>
    );
  }

  /** Toggles the selection */
  onToggle = () => {
    if (this.props.onChange !== undefined) {
      this.props.onChange(!this.props.selected);
    }
  };
}



// WEBPACK FOOTER //
// ./src/ui/widgets/radio-item/radio-item.tsx